import React from 'react';

import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';
import {
  minValue,
  NumberInput,
  RadioButtonGroupInput,
  required,
  SelectInput,
} from 'react-admin';
import { useWatch } from 'react-hook-form';
import BooleanRadioGroupInput from '../../../customFields/BooleanRadioGroupInput';
import creditRiskOperatorChoices from '../../../constants/creditRiskOperators';
import creditRiskDatapointChoices from '../../../constants/creditRiskDatapoints';
import creditRiskProviderNameChoices from '../../../constants/creditRiskProviderNameChoices';

const CreditRisk = () => {
  const shouldPurchase = useWatch({ name: 'ruleParameters.shouldPurchase', defaultValue: true });

  return (
    <Box width="100%">
      <Card variant="outlined">
        <CardContent>
          <Box display="flex" flexDirection="column">
            <Grid size={12}>
              <Typography variant="label">Datapoint to check</Typography>
              <RadioButtonGroupInput
                label={false}
                source="ruleParameters.dataPointToCheck"
                choices={creditRiskDatapointChoices}
                fullWidth
              />
            </Grid>
            <Grid size={12}>
              <SelectInput
                source="ruleParameters.identificationInfo.providerName"
                label="Provider Name"
                choices={creditRiskProviderNameChoices}
                fullWidth
              />
            </Grid>
            <Grid size={12}>
              <Typography variant="label">Comparison Operator</Typography>
              <RadioButtonGroupInput
                label={false}
                source="ruleParameters.operator"
                choices={creditRiskOperatorChoices}
                fullWidth
              />
            </Grid>
            <Grid size={12}>
              <Typography variant="label">Threshold</Typography>
              <NumberInput
                label={false}
                source="ruleParameters.operatorParameters.threshold"
                validate={minValue(0)}
                fullWidth
              />
            </Grid>
            <Grid size={12}>
              <Typography variant="label">Should purchase external data</Typography>
              <BooleanRadioGroupInput
                defaultValue
                source="ruleParameters.shouldPurchase"
                helperText={false}
                label={false}
                validate={required()}
                fullWidth
              />
            </Grid>
            {shouldPurchase && (
              <Grid size={12}>
                <Typography variant="label">Data update frequency</Typography>
                <NumberInput
                  fullWidth
                  source="ruleParameters.updateFreq"
                  label="Days"
                  validate={[required(), minValue(0)]}
                />
              </Grid>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CreditRisk;
